import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LocalstorageService } from "../services/localstorage.service";

@Component({
  selector: "app-change-language",
  template: `<div></div>`,
})
export class LogoutComponent implements OnInit {
  constructor(
    public router: Router,
    private localstorageService: LocalstorageService
  ) {}

  ngOnInit() {
    this.localstorageService.removeAuth();
    this.router.navigate(["/verify/survey"]);
  }
}
